var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating-stars"},[_vm._l((_vm.stars),function(i){return _c('v-icon',{key:i,attrs:{"size":_vm.size,"color":_vm.starColor(i)}},[_vm._v(" "+_vm._s(_vm.starIcon(i))+" ")])}),(_vm.showValue)?_c('span',{staticClass:"rating-value",style:({ fontSize: `${_vm.valueSize}px` })},[_vm._v(" "+_vm._s(_vm.formattedValue)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }